module.exports = __webpack_public_path__ + "site/img/247.773b005d.jpg";